import Vue from 'vue';
import Vuex from 'vuex';
import { app } from "../utils/firebase";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    isEdit: false,
    showSidebar: false,
  },
  getters: {
    auth(state) {
      return state.isAuthenticated;
    },
    header(state) {
      return state.isAuthenticated && state.isEdit ? 'EditHeader' : 'Header';
    },
    menu(state) {
      return state.showMenu;
    }
  },
  mutations: {
    login(state) {
      state.isAuthenticated = true;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.isEdit = false;
      localStorage.isEdit = false;
    },
    sidebar(state, val) {
      state.showSidebar = val;
    }
  },
  actions: {
    signin({ commit }, payload) {
      app.auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(() => {
          const user = app.auth().currentUser;
          if (user) commit('login', payload);
        })
        .catch(function (error) {
          // Handle Errors here.
          var errorMessage = error.message;
          console.log(errorMessage);
        });
    },
    signout({ commit }) {
      app.auth()
        .signOut()
        .then(function () {
          commit('logout');
        }).catch(function (error) {
          console.log(error);
        });
    },

  },
  modules: {
  }
})
